import type { SnakeCasedPropertiesDeep } from 'type-fest';

import type {
  mutation_inspection,
  mutation_profiling,
  mutation_resource,
  mutation_follow_user as MutationFollowUser,
} from '~/infra/api/rpc';
import { api } from '~/infra/api/teller-api';

export type UpdateUserPreferenceSensitiveRequest =
  SnakeCasedPropertiesDeep<mutation_profiling.IUpdateUserPreferenceSensitiveRequest>;

export type ReportStoryViolationRequest = Required<
  SnakeCasedPropertiesDeep<mutation_inspection.IReportStoryViolationRequest>
>;

export type ReportStoryRightViolationRequest = Required<
  SnakeCasedPropertiesDeep<mutation_inspection.IReportStoryRightViolationRequest>
>;

export type ReportSeriesRightViolationRequest = Required<
  SnakeCasedPropertiesDeep<mutation_inspection.IReportSeriesRightViolationRequest>
>;

export type CreateImageRequest =
  SnakeCasedPropertiesDeep<mutation_resource.ICreateImageRequest>;
export type CreateImageResponse =
  SnakeCasedPropertiesDeep<mutation_resource.ICreateImageResponse>;

const SERVICE_PATH = '/mutation.MutationService';

export const reportStoryViolation = async (
  req: ReportStoryViolationRequest
): Promise<void> => {
  await api.post(`${SERVICE_PATH}/ReportStoryViolation`, req);
};

export const reportStoryRightViolation = async (
  req: ReportStoryRightViolationRequest
): Promise<void> => {
  await api.post(`${SERVICE_PATH}/ReportStoryRightViolation`, req);
};

export const reportSeriesRightViolation = async (
  req: ReportSeriesRightViolationRequest
): Promise<void> => {
  await api.post(`${SERVICE_PATH}/ReportSeriesRightViolation`, req);
};

export const createImageResource = async (
  req: CreateImageRequest
): Promise<CreateImageResponse> => {
  const { data } = await api.post(`${SERVICE_PATH}/CreateImage`, req);

  return data;
};

export const updateUserPreferenceSensitive = async (
  req: UpdateUserPreferenceSensitiveRequest
): Promise<void> => {
  await api.post(`${SERVICE_PATH}/UpdateUserPreferenceSensitive`, req);
};

export const followUser = async (
  userId: string,
  mutualFollowSeriesId?: string
): Promise<void> => {
  const req: MutationFollowUser.IFollowUserRequest = {
    userId,
    mutualFollowSeriesId,
  };
  await api.post(`${SERVICE_PATH}/FollowUser`, req);
};

export const unfollowUser = async (userId: string): Promise<void> => {
  const req: MutationFollowUser.IUnfollowUserRequest = {
    userId,
  };
  await api.post(`${SERVICE_PATH}/UnfollowUser`, req);
};

export const deleteMe = async (): Promise<void> => {
  await api.post(`${SERVICE_PATH}/DeleteMe`, {});
};
